
export const getNotesState = (state) => state.notes.notes;